/**
 * 后台布局壳（07 开发文档：导航 + 审计日志查看位）。
 * 左侧导航 + 顶部当前管理员与登出。
 */
import { NavLink, Outlet, useNavigate } from 'react-router';
import { Button } from '@chronospeak/ui';
import { useSession } from '../lib/session';

const NAV = [
  { to: '/dashboard', label: '工作台' },
  { to: '/builders', label: '创作人' },
  { to: '/notices', label: '公告' },
  { to: '/submissions', label: '问卷' },
  { to: '/pages', label: '页面' },
  { to: '/entrances', label: '建筑入口' },
  { to: '/assets', label: '资源' },
  { to: '/settings', label: '设置' },
  { to: '/api-keys', label: 'API Keys' },
];

export function AdminLayout() {
  const { admin, logout } = useSession();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className='admin-shell'>
      <aside className='admin-shell__nav'>
        <p className='admin-shell__brand'>Chronuspeak 运营后台</p>
        <nav aria-label='后台导航'>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `admin-shell__link${isActive ? ' admin-shell__link--active' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className='admin-shell__body'>
        <header className='admin-shell__topbar'>
          <span className='admin-shell__user'>
            {admin?.email}
            {admin?.mustChangePassword ? '（请先修改初始密码）' : ''}
          </span>
          <Button variant='ghost' size='md' onClick={onLogout}>
            登出
          </Button>
        </header>
        <main className='admin-shell__main' id='main'>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
